export default {
    name: "create_account_reference",
    definition: {
        init: function () {
            this.jsonInit({
                "message0": 'create account reference from id:%1',
                "args0": [
                    {
                        "type": "input_value",
                        "name": "ID",
                        "check": ["Account_Id", "String"]
                    }
                ],
                "output": "Account_Reference",
                "colour": 4.5,
                "tooltip": "Creates account reference for target account",
                "helpUrl": "http://www.w3schools.com/jsref/jsref_length_string.asp"
            });
        }
    },
    codeGenerator: (blocklyInstance) => function (block) {
        // String or array length.
        let params = ["ID"];

        params = params.map(param => blocklyInstance.JavaScript.valueToCode(block, param,
            blocklyInstance.JavaScript.ORDER_ATOMIC));

        return [`createAccountReference(${params[0]})`, blocklyInstance.JavaScript.ORDER_NONE];
    }
}